<template>
    <div class="consultation-record">
        <!-- ConsultationRecord -->

        
        <!-- 数据列表区 -->
		<el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%;align: center;">

			<!-- <el-table-column prop="id" label="记录ID" align="center" v-if="false">
			</el-table-column> -->
			<el-table-column prop="visitorId" label="访问ID" align="center">
			</el-table-column>
			<el-table-column prop="content" label="咨询内容" align="center">
			</el-table-column>
			<el-table-column prop="createTimeStr" label="创建时间"  align="center">
			</el-table-column>
			<el-table-column prop="updateTimeStr" label="修改时间" align="center">
			</el-table-column>
			<el-table-column prop="operator" label="操作" align="center">
				<template v-slot:="{row,$index}">
					<el-button type="danger" size="mini" @click="handleReply(row)">
						回复
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页栏 -->
		<pagination :total="totalCounts" @pagination="handlePageChange">
		</pagination>
    </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import {messageList} from '@/api/message'
import {formatDate} from '@/utils/date'

export default {
    name: 'Message',
    components: {
        Pagination,
    },
    data(){
        return{
            listLoading: true,
            listData: [],
            totalCounts: 0,
            listQuery: {
                entityId: this.$store.getters['user/entityId'],
                pageIndex: 1,
                pageSize: 10,
                params: {
                    
                },
                fuzzySearch: true
            },
        }
    },
    methods:{
        handleFilter() {
            this.listLoading = true
            messageList(this.listQuery).then(res => {
                let data = res.pageData
                this.totalCounts = data.totalCounts
                // 对后端数据进行解析
                this.listData = data.datas.map(item => {
                    item.createTimeStr=formatDate(item.createdAt)
                    item.updateTimeStr=formatDate(item.updatedAt)
                    return item
                })
                this.listLoading = false
            })
        },
        handlePageChange(data) {
            this.listQuery.pageIndex = data.page
            this.listQuery.pageSize = data.limit
            this.handleFilter()
        },
        handleReply(row){
            window.open('https://chat.techinao.com/main')
        },
    },
    mounted(){
        this.handleFilter()
    }
}
</script>

<style scoped>

</style>